import {InfiniteScrollPanel} from "../infiniteScroll.js";
import {SavedListingRepository} from "../saved-listings/SavedListingRepository.js";
import {ZIDXListingSummary} from "../base.js";
import {ZIDX} from "../standaloneLibrary.js";

export class ListingThumbnailLayout2 {
    private zidx: ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    render(ss: ZIDXListingSummary, panel: InfiniteScrollPanel): string {
        const isSaved = SavedListingRepository.getInstance(this.zidx).isSaved(ss.id);
        let arrHTML = [];
        arrHTML.push("<div title=\"View Listing\" class=\"zidxSearchResultListingImage");
        if (!panel.visible) {
            arrHTML.push(" zidxImageNotLoaded\" data-image=\"" + ss.photo + "\"");
        }
        if (panel.visible) {
            arrHTML.push("\" style=\"background-image:url('" + ss.photo + "');\"");
        }
        arrHTML.push(">");
        if (this.zidx.zidxBase.renderSaveButton) {
            arrHTML.push(`
                        <div class=\"zidxSearchResultListingSaveButton\">
                            <i title=\"Save property\" data-id='${ss.indexId+":"+ss.id}' data-unique-id='${ss.uniqueId}' saved='${isSaved}' class=\"fa ${isSaved ? 'fa-heart' : 'fa-heart-o'} zidxSearchResultSave\" aria-hidden=\"true\"></i>
                        </div>
                `);
        }
        arrHTML.push("<div class=\"zidxSearchResultListingPrice\">");
        if (ss.price != 0) {
            arrHTML.push("$" + this.zidx.zidxBase.numberFormat(ss.price));
        }
        arrHTML.push("</div></div>\n" +
            "            <div class=\"zidxSearchResultListingTextContainer\">\n" +
            "            <div title=\"View Listing\">\n");
        // arrHTML.push(timestampToDateFormat(ss.createdDatetime)+"<br>");
        let specs = [];
        if (ss.bedrooms != 0) {
            specs.push(ss.bedrooms + " Beds &nbsp; ");
        }
        if (ss.bathrooms != 0) {
            specs.push(ss.bathrooms + " Baths &nbsp; ");
        }
        if (ss.halfBaths != 0) {
            specs.push(ss.halfBaths + " Half Baths &nbsp; ");
        }
        if (ss.sqft != 0) {
            specs.push(this.zidx.numberFormat(ss.sqft) + " SQFT");
        }
        if (specs.length > 0) {
            arrHTML.push("<div class=\"zidxSearchResultListingSpecs\">" + specs.join("") + "</div>");
        }
        let unit="";
        if(ss.address2!=""){
            unit=" Unit #"+ss.address2;
        }
        arrHTML.push(
            "                <div class=\"zidxSearchResultListingAddress\">\n" +
            "                " + ss.address + unit+"&nbsp;<br>\n" +
            "            " + ss.city + ", " + ss.state + " " + ss.postalCode + "\n" +
            "            </div>\n" +
            "            <div class=\"zidxSearchResultListingType\">\n" +
            "                " + ss.type + "&nbsp;\n" +
            "            </div>\n" +
            "            <div class=\"zidxSearchResultListingStatus\">\n" +
            "                " + ss.listStatus + "&nbsp;\n" +
            "            </div>\n" +
            "            </div>\n" +
            // "            <a href=\""+link+"\" class=\"zidxSearchResultListingButton\">\n" +
            // "                View\n" +
            // "            </a>\n" +
            "            </div>");
        return arrHTML.join("");
    }
}